// GCIP Configuration
// Replace these values with your actual GCIP credentials

export const gcipConfig = {
  apiKey: 'AIzaSyBLIhpkWSrmmtSpIRu3q2gCaA4magjpEks',
  projectId: 'prod-data-1',
  authDomain: 'prod-data-1.firebaseapp.com',
  googleClientId: '381340986474-2jvp9vo6jju907bg25b9ge35qnss2n6n.apps.googleusercontent.com',
  tenantId: 'Dashboards-5r85y',
  defaultPassword: 'Osaro12345' // Default password that triggers password reset
};
